import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";

@Component({
	selector: "feedback-icon",
	templateUrl: "./feedback-icon.html",
	styleUrls: ["./feedback-icon.css"],
})
export class FeedbackIconDirective {
	public bShow: boolean;
	@Input()
	public isCorrect: boolean;

	/*constructor() { }

  showIcon(){
    this.bShow = true;
    let owner = this;
    console.log("show icon", owner.bShow);
    setTimeout(function(){
      owner.bShow = false;
    },1000)
  }*/
}
